/* Product page study counter + "See the studies" modal.
   - Count-up: the SAME function as the results page "Behind our Science" numbers
     (assets/personapath-results.js, renderScienceSection > runCountUp): eased = 1 - (1 - p)^8, 3.2 s, grouped with
     toLocaleString(), starts when 30% of it is on screen and runs again each time it scrolls back into view.
   - Modal: the ingredient modal shell (.ppm, opened by assets/pp-modal-helper.js through data-ppm-open) whose body is
     filled on the first press with the studies fragment (templates/product.pp-studies.liquid): one group per ingredient,
     first five shown, "Show all N studies" - the results-page card modal's Research tab. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Counter ──────────────────────────────────────────────── */
  document.querySelectorAll('[data-pp-studyc]').forEach(function (root) {
    var el = root.querySelector('[data-pp-studyc-number]');
    if (!el) return;
    var target = parseInt(root.getAttribute('data-target'), 10) || 0;
    var suffix = root.getAttribute('data-suffix') || '';
    var locale = root.getAttribute('data-locale') || undefined;
    /* One formatter for the whole count (toLocaleString(locale) built a new one on every frame) */
    var nf;
    try { nf = new Intl.NumberFormat(locale); } catch (e) { nf = null; }
    function fmt(n) { return (nf ? nf.format(n) : n.toLocaleString(locale)) + suffix; }

    /* Update the existing text node (a characterData change) instead of replacing it with textContent (remove + add),
       and only when the shown number actually changed. */
    var textNode = null;
    var lastShown = null;
    function show(n) {
      if (n === lastShown) return;
      lastShown = n;
      var t = fmt(n);
      if (!textNode || textNode.parentNode !== el) { el.textContent = t; textNode = el.firstChild; }
      else textNode.nodeValue = t;
    }

    function run() {
      if (reduceMotion) { show(target); return; }
      var totalDuration = 3200;
      var start = performance.now();
      lastShown = null;
      show(0);
      function tick(now) {
        var progress = Math.max(0, Math.min((now - start) / totalDuration, 1));   /* the frame time can precede start: no negatives */
        var eased = 1 - Math.pow(1 - progress, 8);
        show(Math.round(eased * target));
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    if (!('IntersectionObserver' in window)) return;   /* the final number stays as rendered */
    show(0);
    var wasVisible = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !wasVisible) {
          wasVisible = true;
          run();
        } else if (!entry.isIntersecting) {
          wasVisible = false;
        }
      });
    }, { threshold: 0.3 }).observe(root);
  });

  /* ── Modal ────────────────────────────────────────────────── */
  var modal = document.getElementById('ppm-pp-product-studies');
  if (!modal) return;
  var loaded = false;
  var loading = false;

  function collapseLists(scope) {
    var showAllTpl = modal.getAttribute('data-show-all') || 'Show all %n% studies';
    var showLess = modal.getAttribute('data-show-less') || 'Show less';
    scope.querySelectorAll('.pp-wm-studies').forEach(function (group) {
      var list = group.querySelector('.pp-wm-studies__list');
      if (!list) return;
      var count = list.querySelectorAll('p').length;
      if (count <= 5) return;
      var showAll = showAllTpl.replace('%n%', count);
      list.classList.add('is-collapsed');
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'pp-wm-studies__toggle';
      toggle.textContent = showAll;
      toggle.addEventListener('click', function () {
        var collapsed = list.classList.toggle('is-collapsed');
        toggle.textContent = collapsed ? showAll : showLess;
      });
      group.appendChild(toggle);
    });
  }

  function load() {
    if (loaded || loading) return;
    loading = true;
    var slot = modal.querySelector('[data-pp-studies-slot]');
    fetch(modal.getAttribute('data-src'), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var frag = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pp-studies-frag]');
        if (!frag || !frag.querySelector('.pp-wm-studies')) throw new Error('no studies');
        /* DOM methods, not innerHTML: the parsed fragment is imported node by node */
        while (slot.firstChild) slot.removeChild(slot.firstChild);
        Array.prototype.slice.call(document.importNode(frag, true).childNodes).forEach(function (n) { slot.appendChild(n); });
        collapseLists(slot);
        loaded = true;
      })
      .catch(function () {
        while (slot.firstChild) slot.removeChild(slot.firstChild);
        var msg = document.createElement('p');
        msg.className = 'pp-studies-status';
        msg.textContent = modal.getAttribute('data-error') || 'The studies could not be loaded.';
        slot.appendChild(msg);
      })
      .then(function () { loading = false; });
  }

  /* Capture phase: runs before the modal helper's own click handler opens the modal. A fixed-position modal must not
     sit inside a block that has a transform or backdrop-filter, so it is moved to <body> first. */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-ppm-open="pp-product-studies"]');
    if (!opener) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    load();
  }, true);
})();
